import { type FC, memo } from "react";

import { Box, useTheme } from "@mui/material";
import { BaseEdge, type Edge, EdgeLabelRenderer, type EdgeProps, getBezierPath } from "@xyflow/react";

import { type EdgeData } from "../../types";
import AddNodePopover from "./AddNodePopover";

const InternalCustomEdge: FC<EdgeProps<Edge<EdgeData>>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  target,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const {
    palette: { divider },
  } = useTheme();
  return (
    <>
      <BaseEdge interactionWidth={0} id={id} path={edgePath} style={{ stroke: divider, pointerEvents: "none" }} />
      <EdgeLabelRenderer>
        <Box
          sx={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          <AddNodePopover data={data} target={target} />
        </Box>
      </EdgeLabelRenderer>
    </>
  );
};

const CustomEdge = memo(InternalCustomEdge);
export default CustomEdge;
